import { useTheme } from "../context/ThemeContext";

const Footer = () => {
  const { isDark } = useTheme();
  const hunterlabsLogo = isDark ? "/logo192-hlabs-white.png" : "/logo192-hlabs-black.png";

  return (
    <footer className="border-t border-white/60 bg-white/90 px-6 py-5 text-sm text-slate-500 shadow-[0_-8px_24px_-24px_rgba(15,23,42,0.35)]">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-2 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
        <p className="flex items-center justify-center gap-2 sm:justify-start">
          Powered by{" "}
          <a
            href="https://hunterlabs.solutions/"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 font-semibold text-slate-600 transition hover:text-slate-800"
          >
            <img
              src={hunterlabsLogo}
              alt="HunterLabs logo"
              className="h-5 w-5"
            />
            HunterLabs Inc.
          </a>
        </p>
        <p className="text-slate-400">
          Copyright © 2026{" "}
          <a
            href="https://www.rmc2consultancycorp.com/"
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-slate-600 transition hover:text-slate-800"
          >
            RMC2 Consultancy Corporation
          </a>
          . All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
